import React, { useEffect, useRef, useState } from 'react'
import * as S from './styles'
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { IconButton, Skeleton } from '@mui/material';
import axios from 'axios';
import { ChevronLeft } from '@material-ui/icons';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export default function AiInsightsCard({ alert_key }) {

    const [aiInsights, setAiInsights] = useState();
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [typedReasoning, setTypedReasoning] = useState('');
    const [typedFinal, setTypedFinal] = useState('');
    const [reasoningFinished, setReasoningFinished] = useState(false);
    const [finalFinished, setFinalFinished] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);

    const reasoningText = aiInsights?.reasoning ?? '';
    const finalTextFull = aiInsights?.final_response ?? '';

    useEffect(() => {
        const text = reasoningText;
        if (isLoading) return;
        if (!text) return;
        if (reasoningFinished) return;

        let index = 0;
        const interval = setInterval(() => {
            index += 1;
            setTypedReasoning(text.slice(0, index));
            if (index >= text.length) {
                setReasoningFinished(true);
                clearInterval(interval);
            }
        }, 5);
        return () => clearInterval(interval);
    }, [isLoading, reasoningText, reasoningFinished]);

    useEffect(() => {
        const text = finalTextFull;
        const canStart = reasoningFinished && !isLoading && !!text;
        if (!canStart) return;
        if (!text) return;
        if (finalFinished) return;

        let index = 0;
        const interval = setInterval(() => {
            index += 1;
            setTypedFinal(text.slice(0, index));
            if (index >= text.length) {
                setFinalFinished(true);
                clearInterval(interval);
            }
        }, 5);
        return () => clearInterval(interval);
    }, [isLoading, finalTextFull, reasoningFinished, finalFinished]);

    const AiInsightsContent = () => {
        const SkeletonParagraph = (
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="23%" height={12} />
                    <Skeleton variant="text" width="11%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="14%" height={12} />
                    <Skeleton variant="text" width="7%" height={12} />
                    <Skeleton variant="text" width="19%" height={12} />
                    <Skeleton variant="text" width="8%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="12%" height={12} />
                    <Skeleton variant="text" width="7%" height={12} />
                    <Skeleton variant="text" width="17%" height={12} />
                    <Skeleton variant="text" width="10%" height={12} />
                    <Skeleton variant="text" width="15%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="18%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="14%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="21%" height={12} />
                    <Skeleton variant="text" width="6%" height={12} />
                    <Skeleton variant="text" width="17%" height={12} />
                    <Skeleton variant="text" width="8%" height={12} />
                    <Skeleton variant="text" width="13%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="19%" height={12} />
                    <Skeleton variant="text" width="8%" height={12} />
                    <Skeleton variant="text" width="11%" height={12} />
                    <Skeleton variant="text" width="16%" height={12} />
                    <Skeleton variant="text" width="7%" height={12} />
                    <Skeleton variant="text" width="14%" height={12} />
                    <Skeleton variant="text" width="10%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="15%" height={12} />
                    <Skeleton variant="text" width="11%" height={12} />
                    <Skeleton variant="text" width="8%" height={12} />
                    <Skeleton variant="text" width="18%" height={12} />
                    <Skeleton variant="text" width="10%" height={12} />
                    <Skeleton variant="text" width="13%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="17%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="14%" height={12} />
                    <Skeleton variant="text" width="7%" height={12} />
                    <Skeleton variant="text" width="19%" height={12} />
                    <Skeleton variant="text" width="8%" height={12} />
                    <Skeleton variant="text" width="12%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="13%" height={12} />
                    <Skeleton variant="text" width="7%" height={12} />
                    <Skeleton variant="text" width="16%" height={12} />
                    <Skeleton variant="text" width="10%" height={12} />
                    <Skeleton variant="text" width="21%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="11%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="18%" height={12} />
                    <Skeleton variant="text" width="11%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="14%" height={12} />
                    <Skeleton variant="text" width="7%" height={12} />
                    <Skeleton variant="text" width="20%" height={12} />
                    <Skeleton variant="text" width="8%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="16%" height={12} />
                    <Skeleton variant="text" width="8%" height={12} />
                    <Skeleton variant="text" width="19%" height={12} />
                    <Skeleton variant="text" width="6%" height={12} />
                    <Skeleton variant="text" width="13%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="15%" height={12} />
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                    <Skeleton variant="text" width="14%" height={12} />
                    <Skeleton variant="text" width="7%" height={12} />
                    <Skeleton variant="text" width="17%" height={12} />
                    <Skeleton variant="text" width="11%" height={12} />
                    <Skeleton variant="text" width="9%" height={12} />
                    <Skeleton variant="text" width="19%" height={12} />
                    <Skeleton variant="text" width="10%" height={12} />
                </div>
            </div>
        );
        
        if (error) {
            return (
                <div>
                    <S.ErrorText>Não foi possível carregar os insights. Por favor, tente novamente mais tarde.</S.ErrorText>
                </div>
            );
        }

        const showSkeleton = isLoading || (!reasoningFinished && typedReasoning.length === 0);
        if (showSkeleton) return SkeletonParagraph;

        const reasoningDisplay = typedReasoning || reasoningText;
        const showFinal = typedFinal.length > 0 || finalFinished;
        const finalDisplay = typedFinal || finalTextFull;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <S.SectionContainer>
                    <S.TitleWrapper>
                        <SettingsSuggestIcon style={{ fontSize: 20, color: '#0b1f82' }} />
                        <S.Title>Raciocínio</S.Title>
                    </S.TitleWrapper>
                    <S.Description>{reasoningDisplay}</S.Description>
                </S.SectionContainer>
                {showFinal && (
                    <S.SectionContainer>
                        <S.TitleWrapper>
                            <AutoFixHighIcon style={{ fontSize: 20, color: '#0b1f82' }} />
                            <S.Title>Comentário final</S.Title>
                        </S.TitleWrapper>
                        <S.Description>{finalDisplay}</S.Description>
                    </S.SectionContainer>
                )}
            </div>
        );
    }

    useEffect(() => {
        if (!alert_key) return;
        const source = axios.CancelToken.source();
        setIsLoading(true);
        setError(false);
        setTypedReasoning('');
        setTypedFinal('');
        setReasoningFinished(false);
        setFinalFinished(false);

        axios.post(`/dash/alerts/alert/${alert_key}/ai_insights`, null, { cancelToken: source.token })
            .then(response => {
                setAiInsights(response.data);
                setIsLoading(false);
            })
            .catch(err => {
                if (axios.isCancel(err)) return;
                setError(true);
                setIsLoading(false);
            });

        return () => {
            source.cancel('component unmounted');
        };
    }, [alert_key]);

    useEffect(() => {
        if (!contentRef.current) return;
        const id = requestAnimationFrame(() => {
            const nextHeight = contentRef.current?.scrollHeight || 0;
            setContentHeight(nextHeight);
        });
        return () => cancelAnimationFrame(id);
    }, [expanded, aiInsights, isLoading, typedReasoning, typedFinal, reasoningFinished, finalFinished]);

    return (
        <div className="analysisCard" style={{ transition: 'all 0.3s ease', height: 'fit-content' }}>
            <S.Header>
                <S.TitleWrapper>
                    <TipsAndUpdatesIcon style={{ fontSize: 20, color: 'orange' }} />
                    <S.Title>AI Insights</S.Title>
                    {aiInsights?.recommendation ? <S.Badge $recommendation={aiInsights?.recommendation}>{aiInsights?.recommendation}</S.Badge> : null}
                </S.TitleWrapper>
                <S.ButtonWrapper $expanded={expanded}>
                    <IconButton onClick={() => setExpanded(!expanded)}>
                        <ChevronLeft />
                    </IconButton>
                </S.ButtonWrapper>
            </S.Header>
            <div
                style={{
                    overflow: 'hidden',
                    maxHeight: expanded ? contentHeight : 0,
                    opacity: expanded ? 1 : 0,
                    transition: 'max-height 0.35s ease, opacity 0.25s ease',
                }}
            >
                <div ref={contentRef}>
                    <S.Content>
                        <AiInsightsContent />
                    </S.Content>
                </div>
            </div>
        </div>
    )
}